/* import __COLOCATED_TEMPLATE__ from './add-billing-contact.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { closeModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-add-billing-contact-modal';

class AddBillingContactModalComponent extends Component {
  @service api;
  @service('state-managers/application') applicationStateManager;
  @service('commands/company-commands') companyCommandService;
  @service('error-tracker') errorTracker;

  @tracked firstName = '';
  @tracked lastName = '';
  @tracked email = '';

  get className() {
    return CLASS_NAME;
  }

  @task
  *addBillingContact(company, reloadBillingContactsTask) {
    const jsonData = {
      first_name: this.firstName,
      last_name: this.lastName,
      email: this.email,
    };

    try {
      yield this.api.post(`companies/${company.id}/add-billing-contact`, { jsonData });
      closeModal(this);
      this.applicationStateManager.addToast('Saved new billing contact');

      // refresh UI
      yield reloadBillingContactsTask.unlinked().perform(company);
    } catch (e) {
      handleErrorResponseWithModal(this, e, 'Failed to save new billing contact');
    }
  }

  @action
  handleDismiss() {
    closeModal(this);
  }

  @action
  onInput(key, value) {
    this[key] = value;
  }
}

export default AddBillingContactModalComponent;
